function FormField(form, data, containerElement, ajaxUrls) {
	this.form = form;// reference to the parent form.
	this.formId = (form) ? form.formId : null;
	this.data = data;
	this.containerElement = containerElement;
	this.ajaxUrls = ajaxUrls;
	this.type = this.getInputType();

	this.formData = new FormData();
	if(this.formData.set){// check if function exists
		this.formData.set(this.data.name, '');
		this.formData.set('form_id', this.formId);
	}
	else {
		this.formData.append(this.data.name, '');
		this.formData.append('form_id', this.formId);
	}

	// binds
	this.startVerifyInput = this.startVerifyInput.bind(this);
	this.verifyInput = this.verifyInput.bind(this);
	this.processVerifyInput = this.processVerifyInput.bind(this);
	this.setLabelStatus = this.setLabelStatus.bind(this);
	this.saveFile = this.saveFile.bind(this);
	this.setEnabled = this.setEnabled.bind(this);
	this.setDisabled = this.setDisabled.bind(this);

	if(this.ajaxUrls && this.ajaxUrls.verifyFormField) {
		this.verifyRequest = new XMLHttpRequest();
		this.verifyRequest.addEventListener('readystatechange', this.processVerifyInput);

		this.setVerifyEvents();
	}

	if(this.containerElement.classList.contains('is-label-float')) {
		const formElements = this.getFormElements();

		if(formElements.length == 1) {
			formElements[0].addEventListener('change', this.setLabelStatus);
			formElements[0].addEventListener('focus', this.setLabelStatus);
			formElements[0].addEventListener('blur', this.setLabelStatus);
		}

		// if there is already a value prefilled or if the element has focus then update the status
		if(this.getValue() || formElements.indexOf(document.activeElement) >= 0) {
			this.setLabelStatus(false, true);
		}
	}

	// check for edit button
	this.editButton = this.containerElement.querySelector('.input-field-button-edit');
	if(this.editButton){
		this.editButtonParent = this.editButton.parentNode;
		this.editButton.addEventListener('click', function(event){
			event.preventDefault();
			if(event.target.nodeName == 'BUTTON'){
				this.setEnabled();
				this.setFocus();
			}
		}.bind(this));
	}
}

FormField.prototype.isHidden = function() {
	if(!this.containerElement) {
		return null;
	}

	return this.containerElement.classList.contains('is-hidden');
};

FormField.prototype.isAutoFilled = function() {
	return this.containerElement.classList.contains('is-autofilled');
};

FormField.prototype.getFormElements = function() {
	let elements = this.containerElement.querySelectorAll('[name="' + this.data.name + '"]');

	if(!elements) {
		console.warn('No element(s) found with this name: ' + this.data.name);
		return false;
	}

	// convert to array
	if(Array.from) {
		elements = Array.from(elements);
	} else {
		elements = [].slice.call(elements);
	}

	return elements;
};

FormField.prototype.getInputType = function() {
	const formElements = this.getFormElements();

	if(formElements.length < 1) {
		return null;
	}

	// assume first form element represents the type
	const formElement = formElements[0];

	let type = '';

	switch(formElement.nodeName.toLowerCase()) {
		case 'select':
			type = formElement.nodeName.toLowerCase();
			break;
		case 'input':
			type = formElement.getAttribute('type').toLowerCase();
			break;
	}

	return type;
};

FormField.prototype.getValue = function(asString) {
	let elements = this.getFormElements();

	if(!elements || elements.length < 1) {
		console.warn('No formelement(s) found');
		if(asString) {
			return '';
		}
		return null;
	}

	if(typeof Hooks === 'function') {
		const hooks = new Hooks();
		let values = hooks.triggerAction('getFieldValue', [this, elements, asString]);

		if(values) {
			return values;
		}
	}

	if(elements[0].getAttribute('type') == 'file'){
		return elements[0].files[0];
	}
	else if(elements[0].getAttribute('type') == 'radio' || elements[0].getAttribute('type') == 'checkbox') {
		let checkedElements = [];
		elements.forEach(function(element) {
			if(element.checked) {
				checkedElements.push(element);
			}
		});

		if(checkedElements.length === 1) {
			return checkedElements[0].value;
		} else if(checkedElements.length > 0) {
			let values = [];
			checkedElements.forEach(function(element) {
				values.push(element.value);
			});

			if(asString) {
				values.join(',');
			}

			return values;
		} else {
			return '';
		}
	}
	else if(elements.length === 1) {
		return elements[0].value;
	}
};

FormField.prototype.setValue = function(value) {
	let elements = this.getFormElements();

	if(!elements || elements.length < 1) {
		console.warn('No formelement(s) found');
		return false;
	}

	if(elements[0].getAttribute('type') == 'radio' || elements[0].getAttribute('type') == 'checkbox') {
		// To do: not needed atm of writing. Checkbox needs an array as value
	}
	else if(elements.length === 1) {
		elements[0].value = value;
	}
};

// To do: should not take an event!
FormField.prototype.setLabelStatus = function(event, forceFloat) {
	const labelElement = this.containerElement.querySelector('.input-field-label-type-float');

	if(labelElement) {
		if(forceFloat || event && event.type == 'focus' || this.getValue()) {
			labelElement.classList.add('is-floating');
		}
		else {
			labelElement.classList.remove('is-floating');
		}
	}
};

FormField.prototype.setValidated = function() {
	this.containerElement.classList.remove('is-error');
	this.containerElement.classList.remove('is-warning');
	this.containerElement.classList.add('is-validated');
};

FormField.prototype.setEnabled = function() {
	this.containerElement.classList.remove('is-disabled');
	this.removeAutoFilled(); 
	const elements = this.getFormElements();
	elements.forEach(element => {
		element.removeAttribute('disabled');
	});

	//this.editButton = this.containerElement.querySelector('.input-field-button-edit');
	if(this.editButton && this.editButton.nodeType == 1 && this.editButton.parentNode){
		this.editButton.parentNode.removeChild(this.editButton);
	}
};

FormField.prototype.setAutoFilled = function() {
	this.containerElement.classList.add('is-autofilled');
};

FormField.prototype.removeAutoFilled = function() {
	this.containerElement.classList.remove('is-autofilled');
};

FormField.prototype.setVerifyEvents = function() {
	const formElements = this.getFormElements();

	if(!Array.isArray(formElements)) {
		return false;
	}

	for(let i = 0; i < formElements.length; i++) {
		let events = [];
		if(formElements[i].nodeName.toLowerCase() == 'select') {
			events.push('blur');
			events.push('change');
		}

		if(formElements[i].nodeName.toLowerCase() == 'input') {
			switch(formElements[i].getAttribute('type')) {
				case 'file':
					events.push('change');
					break;
				case 'radio':
				case 'checkbox':
					events.push('click');
					events.push('keyup');
					break;
				default:
					events.push('keyup');
					events.push('blur');
					break;
			}
		}
		
		events.forEach((event) => {
			formElements[i].addEventListener(event, this.startVerifyInput);
		});
	}
};

// To do: this should be refactored.. (parts are deprecated now)
FormField.prototype.setStatus = function(status) {
	let elements = [];

	switch(status) {
		case 'loading':
			this.containerElement.classList.add('is-loading');
			this.containerElement.classList.remove('is-validating');
			this.containerElement.classList.remove('is-validated');
			this.containerElement.classList.remove('is-error');
			this.containerElement.classList.remove('is-warning');
			break;
		case 'validating':
			this.containerElement.classList.add('is-validating');
			this.containerElement.classList.remove('is-validated');
			this.containerElement.classList.remove('is-error');
			this.containerElement.classList.remove('is-warning');
			break;
		case 'hidden':
			this.containerElement.classList.add('is-hidden');
			this.setDefault();
			break;
		case 'disabled':
			this.containerElement.classList.add('is-disabled');
			elements = this.getFormElements();
			elements.forEach(element => {
				element.setAttribute('disabled', 'disabled');
			});
			break;
		case 'active':
			this.containerElement.classList.remove('is-disabled');
			elements = this.getFormElements();
			elements.forEach(element => {
				element.removeAttribute('disabled');
			});
			break;
		case 'focus':
			elements = this.getFormElements();
			if( elements.length > 0 ) {
				elements[0].focus();
			}
			break;
		case 'show':
			this.containerElement.classList.remove('is-hidden');
			break;
		case 'reset':
		default:
			this.containerElement.classList.remove('is-loading');
			this.containerElement.classList.remove('is-validating');
			this.containerElement.classList.remove('is-validated');
			this.containerElement.classList.remove('is-error');
			this.containerElement.classList.remove('is-warning');
			break;
	}
};

FormField.prototype.setFocus = function() {
	const elements = this.getFormElements();
	if( elements.length > 0 ) {
		elements[0].focus();
	}
}

FormField.prototype.setDefault = function() {
	let setValue = '';
	const formElements = this.getFormElements();
	
	switch(this.type) {
		case 'radio':
		case 'checkbox':
			if(!this.data.choices) {
				for(let i = 0; i < formElements.length; i++) {
					formElements[i].checked = false;
				}
				return;
			}

			setValue = [];

			for(let i = 0; i < this.data.choices.length; i++) {
				if(this.data.choices[i].isSelected) {
					setValue.push(this.data.choices[i].value);
					break;
				}
			}

			for(let i = 0; i < formElements.length; i++) {
				if(setValue.indexOf(formElements[i].value) >= 0) {
					formElements[i].checked = true;
				}
				else {
					formElements[i].checked = false;
				}
			}
			break;
		case 'select':
			if(!this.data.choices) {
				return;
			}

			for(let i = 0; i < this.data.choices.length; i++) {
				if(this.data.choices[i].isSelected) {
					setValue = this.data.choices[i].value;
					break;
				}
			}

			for(let i = 0; i < formElements.length; i++) {
				if(formElements[i].nodeName == 'SELECT') {
					formElements[i].value = setValue;
				}
			}
			break;
		default:
			if(this.data.defaultValue) {
				setValue = this.data.defaultValue;
			}

			for(let i = 0; i < formElements.length; i++) {
				formElements[i].value = setValue;
			}
			break;
	}
};


FormField.prototype.setDisabled = function() {
	this.containerElement.classList.add('is-disabled');
	
	const elements = this.getFormElements();
	elements.forEach(element => {
		element.setAttribute('disabled', 'disabled');
	});
	
	if(this.editButton && this.editButton.nodeType == 1){
		this.editButtonParent.appendChild(this.editButton);
	}
}

/**
 * Makes the validation data visible to the user by setting classes and creating elements.
 * @param object. validation. Validation object returned from an XMLHttpRequest.
 */

// TODO: if statements unclear, needs refactor
FormField.prototype.setValidation = function(validation) {
	if(!this.containerElement && this.containerElement.nodeType != 1 || !validation) {
		return false;
	}

	if(validation.required) {
		this.containerElement.classList.add('is-required');
	}

	// remove the current message element from the DOM
	if(this.messageElement && this.messageElement.nodeType === 1 && (this.type == 'file' && this.currentEvent == 'change' || this.currentEvent != 'blur' && validation.validated || this.currentEvent == 'blur')) {
		this.messageElement.parentNode.removeChild(this.messageElement);
		this.messageElement = null;
	}

	// set the classes and create the message element
	if(validation.validated === true) {
		if(validation.required) {
			this.containerElement.classList.add('is-validated');
			if(validation.message && (this.type == 'file' && this.currentEvent == 'change' || this.currentEvent == 'blur' || !this.messageElement)) {
				this.messageElement = this.createMessageElement(validation.message, 'validated');
			}
		}
	}
	else {
		if(validation.required) {
			this.containerElement.classList.add('is-error');
			if(validation.message && (this.type == 'file' && this.currentEvent == 'change' || this.currentEvent == 'blur' || !this.messageElement)) {
				this.messageElement = this.createMessageElement(validation.message, 'error');
			}
		}
		else {
			this.containerElement.classList.add('is-warning');
			if(validation.message && (this.type == 'file' && this.currentEvent == 'change' || this.currentEvent == 'blur' || !this.messageElement)) {
				this.messageElement = this.createMessageElement(validation.message, 'warning');
			}
		}
	}

	// if the message element is set then append to the DOM
	if(this.messageElement && this.messageElement.nodeType === 1) {
		try{
			const inputWrapper = this.containerElement.getElementsByClassName('input-field-wrapper');

			if(inputWrapper.length == 1 && inputWrapper[0].nextSibling){
				let node = inputWrapper[0].nextSibling;
				
				while(node && node.nodeType != 1){
					node = node.nextSibling;
				}

				if(node.nodeType == 1){
					node.parentNode.insertBefore(this.messageElement, node);
				}
				else {
					throw 'No next element';
				}
			}
			else {
				throw 'No next element or no wrapper found';
			}
		}
		catch(error){
			this.containerElement.appendChild(this.messageElement);
		}
	}

	if(typeof Hooks === 'function') {
		const hooks = new Hooks();
		hooks.triggerAction('afterFieldValidation', [this.form, this, validation]);
	}
};

FormField.prototype.reset = function() {
	this.setStatus('reset');
	this.setDefault();
};

// To do: should be broken up in methods
FormField.prototype.isStatus = function(status) {
	switch(status){
		case 'validated':
			return this.containerElement.classList.contains('is-validated');
			break;
		case 'disabled':
			return this.containerElement.classList.contains('is-disabled');
			break;
	}
};

FormField.prototype.isValidated = function() {
	return this.containerElement.classList.contains('is-validated');
};

FormField.prototype.isDisabled = function() {
	return this.containerElement.classList.contains('is-disabled');
};

FormField.prototype.startVerifyInput = function(event) {
	if(event && event.type) {
		this.currentEvent = event.type;
	}
	else {
		this.currentEvent = null;
	}

	this.verifyInput();
};

FormField.prototype.verifyInput = function(event) { // to do: should not be use an event as input (needs to be done before starting this method)
	
	this.verifyRequest.abort();
	
	// To do: should check for hidden, but the field conditonal has not run at this point in time

	const formElements = this.getFormElements();

	if(this.currentEvent == 'keyup' && formElements.length == 1 && formElements[0].getAttribute('data-validation-chars') > formElements[0].value.length) {
		this.setStatus('reset');
		return;
	}

	// To do: if type = file, arguably better to upload only the meta instead of the whole file
	if(this.formData.set){// check if function exists
		this.formData.set(this.data.name, this.getValue());
	}
	else {
		this.formData.append(this.data.name, this.getValue());
	}

	this.verifyRequest.open('POST', this.ajaxUrls.verifyFormField);
	this.verifyRequest.send(this.formData);

	this.setStatus('validating');
};

/**
 * Handles the XMLHttpRequest and passes the data to the setValidation method.
 * @return undefined. When the request isn't finished yet.
 */
FormField.prototype.processVerifyInput = function() {
	if(this.verifyRequest.readyState != 4) return;
	if(this.verifyRequest.status != 200 && this.verifyRequest.status != 304) {
		console.log('HTTP error ' + this.verifyRequest.status);
		return;
	}

	if(this.isHidden()){ // To do: should already be checked
		return;
	}

	const validation = JSON.parse(this.verifyRequest.responseText);
	this.setStatus('reset');

	this.setValidation(validation);
};

FormField.prototype.createMessageElement = function(message, messageType) {
	if(!message) {
		return;
	}

	var messageElement = document.createElement('div');
	messageElement.classList.add('form-input-message');

	switch(messageType) {
		case 'validated':
			messageElement.classList.add('form-input-message-validated');
			break;
		case 'error':
			messageElement.classList.add('form-input-message-error');
			break;
		case 'warning':
			messageElement.classList.add('form-input-message-warning');
			break;
	}

	if(typeof message == 'string') {
		messageElement.appendChild(document.createTextNode(message));
	}

	return messageElement;
};

FormField.prototype.saveFile = function(event) {
	// hardcoded for 1 file atm
	if(event.target.files[0]){
		this.uploadedFile = event.target.files[0];
	}
};

export default FormField;